
import logger from "@/utils/logger";

// Add authentication state change listener with context information
export const setupAuthListeners = (supabaseClient: any) => {
  supabaseClient.auth.onAuthStateChange((event: string, session: any) => {
    // Track if this is likely a session refresh rather than a genuine new sign-in
    const previousUserId = sessionStorage.getItem('current_user_id');
    const isLikelySessionRefresh = event === 'SIGNED_IN' && 
      previousUserId && 
      previousUserId === session?.user?.id;
    
    // Store the current user ID for future reference
    if (session?.user?.id) {
      try {
        sessionStorage.setItem('current_user_id', session.user.id);
        sessionStorage.setItem('auth_event_context', isLikelySessionRefresh ? 'refresh' : 'genuine');
        sessionStorage.setItem('auth_event_timestamp', Date.now().toString());
      } catch (e) {
        // Ignore sessionStorage errors
      }
    }
    
    // Trigger appropriate custom events based on the context
    if (event === "SIGNED_IN") {
      if (isLikelySessionRefresh) {
        window.dispatchEvent(new CustomEvent("SUPABASE_SESSION_REFRESHED", { 
          detail: { userId: session?.user?.id }
        }));
      } else {
        window.dispatchEvent(new CustomEvent("SUPABASE_AUTH_SIGNED_IN", {
          detail: { userId: session?.user?.id, isNewLogin: true }
        }));
      }
    } else if (event === "SIGNED_OUT") {
      try {
        sessionStorage.removeItem('current_user_id');
        sessionStorage.removeItem('auth_event_context');
      } catch (e) {
        // Ignore sessionStorage errors
      }
      
      window.dispatchEvent(new Event("SUPABASE_AUTH_SIGNED_OUT"));
    }
  });
};
